import React, { useState } from "react";
import { useDropzone } from "react-dropzone";

const SliderUpload = () => {
  const [imagePreviews, setImagePreviews] = useState([]); // Store local preview URLs

  // Handle file selection
  const onDrop = (acceptedFiles) => {
    const newPreviews = acceptedFiles.map(file => ({
      file,
      preview: URL.createObjectURL(file), // Generate a temporary local URL
    }));
    setImagePreviews(prev => [...prev, ...newPreviews]); // Update state
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div className="p-4 border rounded-md shadow-md w-full max-w-lg">
      <h2 className="text-lg font-bold mb-4">Upload Slider Images</h2>
      
      {/* Dropzone for Image Upload */}
      <div {...getRootProps()} className="border-dashed border-2 p-6 text-center cursor-pointer">
        <input {...getInputProps()} />
        <p>Drag & drop images here, or click to select files</p>
      </div>

      {/* Display Image Previews */}
      <div className="mt-4 grid grid-cols-3 gap-2">
        {imagePreviews.map((img, index) => (
          <img 
            key={index} 
            src={img.preview} 
            alt="Preview" 
            className="w-full h-24 object-cover rounded-md"
          />
        ))}
      </div>
    </div>
  );
};

export default SliderUpload;
